<template>
  <view-wrap>
    <button class="dark" @click="checkout()">Checkout</button>
  </view-wrap>
</template>

<script>
// import Stripe from 'stripe'

export default {
  name: "pay",
  data () {
    return {
      stripe: null
    }
  },
  mounted: function () {
    this.$nextTick(()=> {

    })
    this.stripe = Stripe(this.ENV.token)
  },
  components: {},
  methods: {
    // Log the user out
    checkout: function () {
      this.stripe.redirectToCheckout({
        // Make the id field from the Checkout Session creation API response
        // available to this file, so you can provide it as parameter here
        // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
        // sessionId: '{{CHECKOUT_SESSION_ID}}'
      }).then(function (result) {
        // If `redirectToCheckout` fails due to a browser or network
        // error, display the localized error message to your customer
        // using `result.error.message`.
      });
    }
  }
};
</script>

<style src="./pay.styl" lang="stylus" scoped></style>
